import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUndo } from '@fortawesome/free-solid-svg-icons';
import InternalShell, { useInternalApi } from '../layouts/InternalShell';
import { FINANCE_NAV } from './nav';

const Refunds: React.FC = () => {
    const { api } = useInternalApi();
    const [invoiceRefunds, setInvoiceRefunds] = useState<any[]>([]);
    const [gatewayRefunds, setGatewayRefunds] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => { document.title = 'Refunds & Disputes - Uzima Internal'; }, []);
    useEffect(() => {
        api.get('admin-dashboard/finance/refunds/').then(res => {
            if (res.data?.status === 'success') {
                setInvoiceRefunds(res.data.data.invoice_refunds || []);
                setGatewayRefunds(res.data.data.gateway_refunds || []);
            }
        }).finally(() => setLoading(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <InternalShell activeDashboard="finance_center" subNav={FINANCE_NAV}>
            <h2 className="fw-bold mb-1"><FontAwesomeIcon icon={faUndo} className="me-2 text-primary" />Refunds & Disputes</h2>
            <p className="text-muted mb-4">Invoice-side refunds and gateway-reported refund transactions</p>

            {loading ? (
                <div className="text-center py-5"><div className="spinner-border text-primary" role="status"><span className="visually-hidden">Loading...</span></div></div>
            ) : (
                <div className="row">
                    <div className="col-md-6 mb-4">
                        <div className="card border-0 shadow-sm h-100">
                            <div className="card-header bg-white"><strong>Invoice Refunds</strong></div>
                            <div className="card-body p-0">
                                {invoiceRefunds.length === 0 ? (
                                    <div className="text-center py-4 text-muted">No invoice refunds recorded.</div>
                                ) : (
                                    <table className="table table-hover align-middle mb-0">
                                        <thead className="table-light"><tr><th>Invoice</th><th>Amount</th><th>Reason</th><th>Authorized By</th><th>Date</th></tr></thead>
                                        <tbody>
                                            {invoiceRefunds.map((r: any) => (
                                                <tr key={r.id}>
                                                    <td>{r.invoice}</td>
                                                    <td>{r.amount.toLocaleString()}</td>
                                                    <td className="small">{r.reason}</td>
                                                    <td>{r.authorized_by || '—'}</td>
                                                    <td>{new Date(r.refund_date).toLocaleDateString()}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 mb-4">
                        <div className="card border-0 shadow-sm h-100">
                            <div className="card-header bg-white"><strong>Gateway Refunds</strong></div>
                            <div className="card-body p-0">
                                {gatewayRefunds.length === 0 ? (
                                    <div className="text-center py-4 text-muted">No gateway refunds recorded.</div>
                                ) : (
                                    <table className="table table-hover align-middle mb-0">
                                        <thead className="table-light"><tr><th>Transaction</th><th>Amount</th><th>Status</th><th>Date</th></tr></thead>
                                        <tbody>
                                            {gatewayRefunds.map((r: any) => (
                                                <tr key={r.id}>
                                                    <td>{r.transaction_id}</td>
                                                    <td>{r.currency} {r.amount.toLocaleString()}</td>
                                                    <td><span className="badge bg-secondary">{r.status}</span></td>
                                                    <td>{r.date ? new Date(r.date).toLocaleDateString() : '—'}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </InternalShell>
    );
};

export default Refunds;
